export enum MailboxFolderEnums {
  IN,
  UNREAD,
  OUT,
}
